import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { contactPageData, greeting } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;
const blogSection = contactPageData.blogSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;

class Contact extends Component {
  render() {
    const theme = this.props.theme;
    const contactCards = [
      {
        title: phoneSection.title,
        detail: phoneSection.subtitle,
        href: `mailto:${phoneSection.subtitle}`,
        icon: "fas fa-envelope",
      },
      {
        title: blogSection.title,
        detail: "linkedin.com/in/tongyu-hu-41b65b24a",
        href: blogSection.link,
        icon: "fab fa-linkedin-in",
      },
      {
        title: "GitHub",
        detail: "github.com/tongyuuu",
        href: greeting.githubProfile,
        icon: "fab fa-github",
      },
      {
        title: addressSection.title,
        detail: addressSection.subtitle,
        href: addressSection.location_map_link,
        icon: "fas fa-map-marker-alt",
      },
    ];

    return (
      <div className="contact-main">
        <Header theme={theme} />
        <main className="modern-contact-shell">
          <Fade bottom duration={1000} distance="32px">
            <section className="modern-contact-hero">
              <div className="contact-copy">
                <p className="contact-eyebrow">Sydney, Australia</p>
                <h1 className="contact-heading-text" style={{ color: theme.text }}>
                  {ContactData.title}
                </h1>
                <p
                  className="contact-header-detail-text"
                  style={{ color: theme.secondaryText }}
                >
                  {ContactData.description}
                </p>
                <div className="contact-action-row">
                  <a className="contact-primary-action" href={`mailto:${phoneSection.subtitle}`}>
                    Email me
                  </a>
                  <a
                    className="contact-secondary-action"
                    href={blogSection.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn
                  </a>
                </div>
                <SocialMedia theme={theme} />
              </div>

              <div className="contact-profile-card">
                <img
                  className="contact-profile-photo"
                  src={require(`../../assests/images/${ContactData.profile_image_path}`)}
                  alt="Tongyu Hu"
                />
                <div className="contact-profile-copy">
                  <h2>Tongyu Hu</h2>
                  <p>Law / Computer Science at the University of Sydney</p>
                </div>
              </div>
            </section>
          </Fade>

          <Fade bottom duration={1000} distance="32px">
            <section className="contact-card-grid">
              {contactCards.map((card) => {
                return (
                  <a
                    className="contact-method-card"
                    href={card.href}
                    target={card.href.startsWith("mailto:") ? "_self" : "_blank"}
                    rel="noopener noreferrer"
                    key={card.title}
                  >
                    <span className="contact-method-icon">
                      <i className={card.icon} />
                    </span>
                    <span className="contact-method-label">{card.title}</span>
                    <span className="contact-method-detail">{card.detail}</span>
                  </a>
                );
              })}
            </section>
          </Fade>
        </main>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Contact;
